import * as React from "react";
import { CSSProperties } from "react";
import { Scroll } from "../../../../../../../react-core/Utils/Scroll";

interface ISlideNavigatorProps {
    tabs: any;
    tabIndex: any;
    onClick: (index) => void;
}

const dotStyling: CSSProperties = {
    display: "inline-block",
    borderColor: "var(--link)",
    borderWidth: "8px",
    borderStyle: "solid",
    borderRadius: "8px",
    boxSizing: "border-box",
    width: "8px",
};

export const SlideNavigator = (props: ISlideNavigatorProps) => {
    const { tabs, tabIndex, onClick } = props;

    const tabArray = Object.values(tabs);
    const activeTabIndex = tabArray.indexOf(tabIndex);

    const links: JSX.Element[] = tabArray.map((tab, index) => {
        const opacity = index <= activeTabIndex ? 1 : 0.5;

        return (
            <a
                key={`link-${index}`}
                className="ml-10 mr-10"
                onClick={() => {
                    Scroll.scrollTop();
                    onClick(tab);
                }}
                style={{ ...dotStyling, opacity }}
            ></a>
        );
    });

    return (
        <div className="container">
            <div className="text-center pt-10">{links}</div>
        </div>
    );
};
